import _ from 'lodash';
import stringHash from 'string-hash';
import * as FileSystemService from '../services/file/fileSystemService';
import { getExtensionFromMimetype } from '../services/mimetypes/mimetypesService';
import { EXTENSION } from '../const';

export function getClassroomAppPath() {
  return FileSystemService.getBaseUrl();
}

export function getClassroomFolderPath(userId, classId) {
  return `${FileSystemService.getBaseUrl()}/${userId}/${classId}`;
}

export function getBookFolderPath(bookContext) {
  const classPath = getClassroomFolderPath(bookContext.userId, bookContext.classId);
  let hashedBookActivityId = stringHash(bookContext.bookActivityId);
  return `${classPath}/${hashedBookActivityId}`;
}

export function getBookDownloadCheckFile(bookContext) {
  const bookFolderPath = getBookFolderPath(bookContext);
  return `${bookFolderPath}/download.json`;
}

export function getUnitDownloadCheckFile(unitContext) {
  const unitFolderPath = getUnitFolderPath(unitContext);
  return `${unitFolderPath}/download.json`;
}

export function getLessonContentFolderPath(context) {
  const hashedLessonActivityId = getHashedActivityId(context.lessonActivityId);
  const unitPath = getUnitFolderPath(context);
  return `${unitPath}/${hashedLessonActivityId}`;
}

export function getActivityContentDestinationPath(activityContext) {
  return activityContext.lessonActivityId
    ? getLessonContentFolderPath(activityContext)
    : getUnitFolderPath(activityContext);
}

export function getActivityContentFilePath(activityContext, format) {
  let path = '';

  if (activityContext.lessonActivityId) {
    const lessonPath = getLessonContentFolderPath(activityContext);
    const fileExtension = getExtensionFromMimetype(format);
    const lessonName = _.last(lessonPath.split('/'));
    path = `${lessonPath}/${lessonName}.${fileExtension}`;
  } else {
    const unitPath = getUnitFolderPath(activityContext);
    const fileExtension = getExtensionFromMimetype(format);
    const unitName = _.last(unitPath.split('/'));
    path = `${unitPath}/${unitName}.${fileExtension}`;
  }
  return path;
}

export let getHashedActivityId = function(unitActivityId) {
  return stringHash(unitActivityId);
};

export function getUnitFolderPath(unitContext) {
  const bookPath = getBookFolderPath(unitContext);
  const hashedUnitActivityId = getHashedActivityId(unitContext.unitActivityId);
  return `${bookPath}/${hashedUnitActivityId}`;
}

export function getAuthoringResourcesFolderPath(unitContext) {
  return `${getUnitFolderPath(unitContext)}/authoringResources`;
}

export function getUnitZipFilePath(unitContext) {
  const unitPath = getUnitFolderPath(unitContext);
  return `${unitPath}.${EXTENSION.ZIP}`;
}

export function getUnitScaFilePath(unitContext) {
  const unitPath = getUnitFolderPath(unitContext);
  return `${unitPath}/scaResponse.json`;
}

export function getUnitCmi5FilePath(unitContext) {
  const unitPath = getUnitFolderPath(unitContext);
  return `${unitPath}/cmi5_offline.json`;
}

export function getUnitClassroomComponentsFilePath(unitContext) {
  const unitPath = getUnitFolderPath(unitContext);
  return `${unitPath}/components_offline.json`;
}

export function getUnitNotesFilePath(unitContext) {
  const unitPath = getUnitFolderPath(unitContext);
  return `${unitPath}/notes_offline.json`;
}

export function getUnitIndexFilePath(unitContext) {
  const unitPath = getUnitFolderPath(unitContext);
  return `${unitPath}/index.html`;
}

export function getCdnFolderPath() {
  return `${FileSystemService.getBaseUrl()}/cdn`;
}

export function getCdnIndexPath(bookContext) {
  const bookCdnPath = getCdnFolderPath(bookContext);
  return `${bookCdnPath}/index.html`;
}

export function getCdnZipPath(bookContext) {
  const bookCdnPath = getCdnFolderPath(bookContext);
  return `${bookCdnPath}.zip`;
}

export function getCdnVersionFilePath(context) {
  const cdnFolderPath = getCdnFolderPath(context);
  return `${cdnFolderPath}/package.json`;
}

export function getSkinServiceParentFolderPath(customerId) {
  const userPath = `${FileSystemService.getBaseUrl()}/skins/${customerId}`;
  return `${userPath}`;
}

export function getSkinFolderPath(customerId) {
  const parentFolderPath = getSkinServiceParentFolderPath(customerId);
  return `${parentFolderPath}/skin`;
}

export function getSkinColors(customerId) {
  const parentFolderPath = getSkinServiceParentFolderPath(customerId);
  return `${parentFolderPath}/skin`;
}

export function getSkinZipFilePath(customerId) {
  const skinFolderPath = getSkinFolderPath(customerId);
  return `${skinFolderPath}.zip`;
}

export function getSkinServiceUrlFilePath(customerId) {
  const parentFolderPath = getSkinServiceParentFolderPath(customerId);
  return `${parentFolderPath}/skin`;
}

export function getSkinVersionFilePath(customerId) {
  const skinFolderPath = getSkinFolderPath(customerId);
  return `${skinFolderPath}/version.json`;
}

export function getUnitResourceFolderPath(unitFolderPath) {
  return `${unitFolderPath}/authoringResources`;
}

export function getDocumentLessonsFolderPath(unitFolderPath) {
  return `${unitFolderPath}/documentLessons`;
}

export function getUnitResourceFilePath(resourcesFolderPath, resource) {
  const url = resource.url;
  const hashedResourceUrl = stringHash(url);
  const fileExtension = url.slice(((url.lastIndexOf('.') - 1) >>> 0) + 2);

  return `${resourcesFolderPath}/${hashedResourceUrl}.${fileExtension}`;
}

export function getDocumentLessonFilePath(lessonsFolderPath, lesson) {
  const fileExtension = getExtensionFromMimetype(lesson.format);
  const hashedLessonActivityId = stringHash(lesson.id);

  return `${lessonsFolderPath}/${hashedLessonActivityId}.${fileExtension}`;
}
